import "../../../../content/departments/sites/sites.css";
import * as React from 'react';
export default {
  React
};